import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'react-tippy/dist/tippy.css';
import { GachaThemeProvider } from './theme';
import { StoreContextProvider } from './store';

ReactDOM.render(
  <GachaThemeProvider>
    <StoreContextProvider>
      <App />
    </StoreContextProvider>
  </GachaThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
